import { useContext } from "react";

import { AuthContext } from "~/auth/AuthProvider";
import { hasUserAdminAccess } from "~/auth/roleChecks";
import useMyUser from "~/auth/useMyUser";

const useCanManageTenantSettings = (): boolean => {
	const { currentUser } = useContext(AuthContext);
	const { myUser } = useMyUser();
	return hasUserAdminAccess(currentUser, myUser?.roles);
};

export default useCanManageTenantSettings;
